window.addEventListener('load', function(){

    /*********************************************************** 
        Acordion effect for faq list items
    ************************************************************/
   
    var faqItems = document.getElementsByClassName('faq-item');
    for (i = 0; i < faqItems.length; i++) {

      faqItems[i].addEventListener("click", (e) => {
            
            // clear elms min-height & state
            for (i = 0; i < faqItems.length; i++) {
                if (faqItems[i] != e.currentTarget){
                  faqItems[i].ariaExpanded = 'false';
                }
                faqItems[i].getElementsByClassName('faq-item-description')[0].style.maxHeight = null;
            }
            
            // register elm description
            var description = e.currentTarget.getElementsByClassName('faq-item-description')[0];  
            
            // current areaExpended State
            e.currentTarget.ariaExpanded = e.currentTarget.ariaExpanded !== 'true';
            var expended = (e.currentTarget.ariaExpanded === 'true');
            
            // add height to clicked item
            if(expended == true) {
                description.style.maxHeight = description.scrollHeight + "px";
            }
        });
    }
});